import { Card, CardHeader, CardContent, Typography, Grid, Container, CircularProgress, Box } from "@mui/material";
import { Link } from 'react-router-dom';
import { I18nContext } from "../../I18nProvider";
import { useContext, useEffect, useState } from "react";
import IresearhService from "../../services/IresearchService";
import { Unidad } from "../../Interface/IUnidad";


export const UnidadesAcademica: React.FC<{}> = () => {
    const [unidades, setUnidades] = useState<Unidad[]>([]);
    const [loading, setLoading] = useState<boolean>(true); 
    const context = useContext(I18nContext);

    if (context === null) {
        throw new Error(
            "The I18n context is not initialized. Make sure you have the provider set up correctly."
        );
    }

    useEffect(() => {
        IresearhService.getUnidades()
            .then((unidadesData: { listData: Unidad[] }) => {
                const unidadesAcademicas = unidadesData.listData.filter((unidad) => unidad.idtipounidad === 2);
                setUnidades(unidadesAcademicas);
            })
            .catch((error) => {
                console.error("Error fetching user data from backend:", error);
            })
            .finally(() => {
                setLoading(false); 
            });
    }, []);


    return (
        <Container>
            <h1>{context.t.translate("home.uAcademica")}</h1>

            {loading ? ( 
                <Box display="flex" justifyContent="center" alignItems="center" height="60vh">
                    <CircularProgress />
                </Box>
            ) : (
                <Grid container justifyContent="center" spacing={4} alignItems="center">
                    <Grid item xs={12} sm={10} md={10} container spacing={8} justifyContent="center">

                        {unidades.map((item) => {
                            const unidad_url = `/unidad/${ item.siglas.toLowerCase()}`;
                            return (
                                <Grid item xs={12} sm={6} md={4} key={item.idunidad}>
                                    <Link to={unidad_url} state={{ id: item.idunidad }} style={{ textDecoration: 'none' }}>
                                        <Card sx={{ width: '100%', height: 200, display: 'flex', flexDirection: 'column' }}>
                                            <CardHeader sx={{ backgroundColor: item.color || "#243165" , color: "white", height: 40 }} title={item.siglas} />
                                            <CardContent sx={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center" }}>
                                                <Typography variant="body1" align="center">
                                                    {item.nombreunidad}
                                                </Typography>
                                            </CardContent>
                                        </Card>
                                    </Link>
                                </Grid>
                            );
                        })}

                    </Grid>
                </Grid>
            )}
        </Container>
    );
};
